import { request } from "@insite/client-framework/Services/ApiService";

// Types for the API response
export interface CentroConnectPerson {
    name: string;
    title: string;
    branch: string;
    expertise: string;
    avatar: string;
}

export interface CentroConnectCategory {
    key: string;
    label: string;
    subtitle: string;
    items: string[];
}

export interface CentroConnectExpertiseCard {
    label: string;
    avatarCount: number;
}

export interface CentroConnectSearchResult {
    people: CentroConnectPerson[];
    categories: CentroConnectCategory[];
    brands: string[];
    branches: string[];
}

export interface CentroConnectInitialData {
    coworkers: CentroConnectPerson[];
    expertiseCards: CentroConnectExpertiseCard[];
}

// API Endpoints (dummy - will be updated when BE provides actual endpoints)
const CENTRO_CONNECT_INITIAL_DATA_API = "/api/v2/centroconnect/initialdata";
const CENTRO_CONNECT_SEARCH_API = "/api/v2/centroconnect/search";

// Get initial data (coworkers and expertise spotlight)
export async function getCentroConnectInitialData(): Promise<CentroConnectInitialData> {
    try {
        return await request<CentroConnectInitialData>(CENTRO_CONNECT_INITIAL_DATA_API, "GET", {});
    } catch (error) {
        // Return dummy data for now while waiting for BE
        return getDummyInitialData();
    }
}

// Search functionality
export async function searchCentroConnect(query: string): Promise<CentroConnectSearchResult> {
    try {
        return await request<CentroConnectSearchResult>(`${CENTRO_CONNECT_SEARCH_API}?query=${query}`, "GET", {});
    } catch (error) {
        // Return dummy search results for now while waiting for BE
        return getDummySearchResults(query);
    }
}

// Dummy data functions - will be replaced with actual API calls
function getDummyInitialData(): CentroConnectInitialData {
    return {
        coworkers: [
            {
                name: "Brandon Scordino",
                title: "Title Here",
                branch: "Branch",
                expertise: "Steam Traps, Automation and Robotics",
                avatar: "xyz.png",
            },
            {
                name: "John Smith",
                title: "Senior Engineer",
                branch: "Memphis Branch",
                expertise: "Pumps, Valves",
                avatar: "xyz.png",
            },
            {
                name: "Sarah Johnson",
                title: "Product Specialist",
                branch: "Nashville Branch",
                expertise: "ISO Valves, Electrical",
                avatar: "xyz.png",
            },
        ],
        expertiseCards: [
            { label: "Steam Traps", avatarCount: 3 },
            { label: "Automation", avatarCount: 2 },
            { label: "Pumps", avatarCount: 1 },
            { label: "Valves", avatarCount: 3 },
            { label: "Valves2", avatarCount: 3 },
        ],
    };
}

function getDummySearchResults(query: string): CentroConnectSearchResult {
    return {
        people: [
            {
                name: "Brandon Scordino",
                title: "Title Here",
                branch: "Branch",
                expertise: "Steam Traps, Automation and Robotics,",
                avatar: "xyz.png",
            },
            {
                name: "Brandon Scordino",
                title: "Title Here",
                branch: "Branch",
                expertise: "Steam Traps, Automation and Robotics,",
                avatar: "xyz.png",
            },
            {
                name: "Brandon Scordino",
                title: "Title Here",
                branch: "Branch",
                expertise: "Steam Traps, Automation and Robotics,",
                avatar: "xyz.png",
            },
            {
                name: "Brandon Scordino",
                title: "Title Here",
                branch: "Branch",
                expertise: "Steam Traps, Automation and Robotics,",
                avatar: "xyz.png",
            },
        ],
        categories: [
            {
                key: "categories",
                label: "Product Categories",
                subtitle: "Find SMEs by Product Category",
                items: [
                    "ISO Valves",
                    "Pneumatic and Electronic Controls",
                    "Steam Products",
                    "Solenoid Driven Metering Pumps",
                    "Process Systems and Process Equipment",
                    "Tools & Supplies",
                    "Electrical",
                    "Pumps",
                    "Valves",
                ],
            },
            {
                key: "brands",
                label: "Brands",
                subtitle: "Find SMEs by Brand",
                items: ["ASCO", "Sisco", "BASCO", "Tescom Anderson Greenwood", "Scott Turbon Mixer Inc."],
            },
            {
                key: "branches",
                label: "Branches",
                subtitle: "Find SMEs by Branch",
                items: ["Memphis Branch", "Nashville Branch", "Atlanta Branch", "Houston Branch", "Dallas Branch"],
            },
        ],
        brands: ["ASCO", "Sisco", "BASCO", "Tescom Anderson Greenwood", "Scott Turbon Mixer Inc."],
        branches: ["Memphis Branch", "Nashville Branch", "Atlanta Branch", "Houston Branch", "Dallas Branch"],
    };
}
